/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TariffaMensaRegolaForm } from './tariffa-mensa-regola-form';


export interface TariffaMensaUpsertForm { 
    version?: number;
    numero_pasti_per_contributo: number;
    is_non_autosufficiente_esente?: boolean;
    regole?: Array<TariffaMensaRegolaForm>;
    is_esenti_esclusi_conteggio_fratelli?: boolean;
    decorrenza_esenzione?: TariffaMensaUpsertFormDecorrenzaEsenzioneEnum;
}
export enum TariffaMensaUpsertFormDecorrenzaEsenzioneEnum {
    TUTTO_IL_SERVIZIO = 'TUTTO_IL_SERVIZIO',
    DAL_MESE = 'DAL_MESE'
};



